<template>
    <div class="feedback-step">
        <div v-if="!surveyAlreadyCompleted" class="text text-large has-text-weight-bold has-margin-bottom-30">
            <img class="thanks-logo" src="/images/marque-logo-white.svg" />
            <h4 class="heading-second--grey">Thanks for your responses today. If you have indicated that you want to talk to someone, they will be in touch. We will check in again soon.</h4>
        </div>
        <div v-else class="text text-large has-text-weight-bold has-margin-bottom-30">
            <div class="container__inner">
                <div class="question-container" style="display: flex">
                    <img class="logo--ths-small" src="/images/marque-logo-small.svg" style="height: 41px;margin-right: 15px;" />
                    <h4 class="heading-second--grey">Oops, you have already completed this survey. Please call us if you have any questions.</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StepEnd",

        props: {
            surveyAlreadyCompleted: {
                type: Boolean
            },
            savedAnswers: {
                type: Object
            }
        },
        
        mounted () {
            if (!this.surveyAlreadyCompleted)
                this.$store.dispatch("setSurveyComplete", { id: 1 })
        },
        
        data() {
            return {
                lastAnswer: undefined
            }
        }
    }
</script>